import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";
import { DOSSIERS, DOSSIER_FILENAMES } from "../../i18n/dossiers";

// --- ICONOS EXACTOS (Lucide React) ---
function BarChart3Icon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M3 3v18h18" />
      <path d="M18 17V9" />
      <path d="M13 17V5" />
      <path d="M8 17v-3" />
    </svg>
  );
}

function ActivityIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  );
}

function HeartIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  );
}

function ChevronRightIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}

export function ValueProp() {
  const { t, lang } = useLandingLang();
  const benefits = [
    {
      title: t("valOptTitle"),
      desc: t("valOptDesc"),
      icon: <BarChart3Icon className="text-sky-500 w-6 h-6" />,
    },
    {
      title: t("valInnTitle"),
      desc: t("valInnDesc"),
      icon: <ActivityIcon className="text-sky-500 w-6 h-6" />,
    },
    {
      title: t("valCareTitle"),
      desc: t("valCareDesc"),
      icon: <HeartIcon className="text-sky-500 w-6 h-6" />,
    },
  ];

  return (
    <section className="pt-12 pb-24 px-6 text-center lg:text-left text-slate-700 bg-slate-50">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-20 items-center">
        {/* COLUMNA IZQUIERDA: Lista de Beneficios */}
        <div className="flex-1 space-y-8">
          <h2 className="text-4xl !font-black leading-tight tracking-tight text-slate-700">
            {t("valueTitle1")}{" "}
            <span className="text-sky-500 italic underline decoration-sky-200 decoration-8 underline-offset-[-2px]">
              {t("valueTitle2")}
            </span>
          </h2>

          <div className="space-y-6">
            {benefits.map((b, i) => (
              <div
                key={i}
                className="flex gap-4 p-4 rounded-2xl hover:bg-white hover:shadow-sm transition-all border border-transparent hover:border-slate-200 text-left"
              >
                <div className="bg-white p-3 rounded-xl shadow-sm border border-slate-100 shrink-0 text-slate-700">
                  {b.icon}
                </div>
                <div className="text-left">
                  <p className="!font-bold text-slate-700 uppercase tracking-tight !font-black">
                    {b.title}
                  </p>
                  <p className="text-sm text-slate-500 leading-relaxed font-medium">
                    {b.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* COLUMNA DERECHA: Card 'Preparados para el futuro' */}
        <div className="flex-1 w-full bg-white p-12 rounded-[3.5rem] border border-slate-200 shadow-2xl relative overflow-hidden group">
          {/* Círculo decorativo en la esquina */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-slate-50 rounded-full -mr-16 -mt-16 group-hover:scale-110 transition-transform"></div>

          <div className="space-y-6 relative z-10 text-center lg:text-left">
            <h4 className="text-xl !font-black uppercase tracking-tight">
              {t("futureTitle")}
            </h4>
            <p className="text-slate-500 font-medium leading-relaxed">
              {t("futureDesc")}
            </p>

            <div className="pt-6">
              {/* ✅ ENLACE DE DESCARGA: Usamos 'a' en lugar de button */}
              <a
                href={DOSSIERS[lang]}
                download={DOSSIER_FILENAMES[lang]}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-4 bg-gradient-to-r from-sky-400 to-blue-500 text-white rounded-[2rem] !font-bold shadow-xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center gap-3 group uppercase tracking-widest text-[11px] border-0 cursor-pointer no-underline"
              >
                {t("downloadDossier")}{" "}
                <ChevronRightIcon className="w-[18px] h-[18px] group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
